import { render, staticRenderFns } from "./ServiceLabItems.vue?vue&type=template&id=d402da66"
import script from "./ServiceLabItems.vue?vue&type=script&lang=js"
export * from "./ServiceLabItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports